import {
    PLATFORM_TYPE,
    useBusinessStore,
    useOnReconnect,
    useRegisterConfiguration,
    useStaffSessionStore,
    useUserInfo,
} from '@register-ui/utils';
import {
    useUnleashClient,
    useUnleashContext,
} from '@unleash/proxy-client-react';
import { useCallback, useEffect } from 'react';

export function FlagContextData() {
    const { config } = useRegisterConfiguration();
    const { businessInfo } = useBusinessStore();
    const client = useUnleashClient();
    const updateContext = useUnleashContext();

    const user = useUserInfo();

    const { staffId } = useStaffSessionStore();

    const currentBusinessId = config.businessId || businessInfo.businessId;

    const handleUpdateContext = useCallback(async () => {
        const context = client.getContext();

        if (!currentBusinessId) {
            await updateContext({
                ...context,
                userId: undefined,
                properties: {
                    businessId: '',
                    email: '',
                    platformType: PLATFORM_TYPE.WEB,
                },
            });
            return;
        }

        if (
            context.userId === staffId &&
            context.properties?.businessId === currentBusinessId
        ) {
            return;
        }

        await updateContext({
            userId: staffId ?? '',
            properties: {
                businessId: currentBusinessId,
                email: user?.email ?? '',
                platformType: PLATFORM_TYPE.WEB,
            },
        });
    }, [updateContext, staffId, currentBusinessId, client, user?.email]);

    useEffect(() => {
        handleUpdateContext();
    }, [currentBusinessId, staffId, handleUpdateContext]);

    const refreshFlags = useCallback(() => {
        client.stop();
        client.start();
    }, [client]);

    useOnReconnect(refreshFlags);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'visible') {
                refreshFlags();
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange,
            );
        };
    }, [refreshFlags]);

    return null;
}
